module.exports = __webpack_public_path__ + "static/media/20210403_223132_873_IMG_0006.832bf52f.jpg";